<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <contractor-check-in-page /><br><br><br>
    </div>
  </div>
</template>

  <script>
  import ContractorCheckInPage from '../../../Components/Contractor/ContractorCheckInPage.vue';
    export default {
      name: 'ContractorCheckInPage',
      components: {
        'contractor-check-in-page': ContractorCheckInPage,
    },
  };
  </script>

  <style scoped>

  </style>
